import { MY_ORDER } from "../constants/ActionTypes";

const initialMyAccountOrderState = {
    MY_ORDER_NOW_YEAR : 2010,
    MY_ORDER_STATUS_TYPE_MODULE : '',
    MY_ORDER_STATUS_TYPE : [1,0,0,0,0],
    MY_ORDER_TIME_MODULE_SHOW : false,
    MY_ORDER_NOW_TIME_VALUE : '最近三个月订单',
    MY_ORDER_NOW_TIME_VALUE_CODE : 'Q',
    MY_ORDER_NOW_STATUS_CODE : '',
    MY_ORDER_PAGE_CURRENT : 1,
    MY_ORDER_PAGE_TOTAL : 0,
    MY_ORDER_LIST_MODULE : [],
    MY_ORDER_SHOW_COMMENTS : false,
    MY_ORDER_STATUS_MODULE_SHOW : false,
    MY_ORDER_NOW_STATUS_VALUE : '全部状态',
    MY_ORDER_COMMENTS_NOW_OP : '',
    MY_ORDER_COMMENTS_NOW_ORDER_ID : '',
    MY_ORDER_COMMENTS_NOW_SKUID : '',
    MY_ORDER_NOW_PAY_ORDER_ID : '',
    MY_ORDER_NOW_PAY_MONEY : '',
    MY_ORDER_DOWN_PAY_BOX_SHOW : false,
    MY_ORDER_CANCEL_REASON_SHOW : false,
    MY_ORDER_CANCEL_REASON_LIST : ["更换或添加新商品","错过促销活动","重复下单","现在不想购买","去门店购买","支付不成功","等待时间过长","更换支付方式","其他"],
    MY_ORDER_ORDER_ID: '',
    MY_ORDER_LOGISTIC_SHOW : false,
    MY_ORDER_LOGISTIC_MODEL : '',
    MY_ORDER_LOGISTIC_INDEX : null,
    MY_ORDER_CANCEL_REASON_STATUS : null,
    PAY_TOGETHER_POPUP_TOOGLE : false,
    MY_ORDER_ORDER_CHECK:[],
};

export default function ( state = initialMyAccountOrderState, action = {} ){

    switch( action.type ){
        
        case MY_ORDER.MY_ORDER_STATUS_TYPE_MODULE:
        return Object.assign({},state,{
            MY_ORDER_STATUS_TYPE_MODULE : action.MY_ORDER_STATUS_TYPE_MODULE
        });
        break;

        case MY_ORDER.MY_ORDER_NOW_YEAR:
        return Object.assign({},state,{
            MY_ORDER_NOW_YEAR : action.MY_ORDER_NOW_YEAR
        });
        break;

        case MY_ORDER.MY_ORDER_LIST_MODULE:
        return Object.assign({},state,{
            MY_ORDER_LIST_MODULE : action.MY_ORDER_LIST_MODULE,
            MY_ORDER_PAGE_TOTAL : action.MY_ORDER_PAGE_TOTAL,
            MY_ORDER_SHOW_COMMENTS : action.MY_ORDER_SHOW_COMMENTS,
        });
        break;

        case MY_ORDER.MY_ORDER_HISTORY:
        return Object.assign({},state,{
            MY_ORDER_PAGE_CURRENT : action.MY_ORDER_PAGE_CURRENT,
            MY_ORDER_NOW_TIME_VALUE : action.MY_ORDER_NOW_TIME_VALUE,
            MY_ORDER_NOW_TIME_VALUE_CODE : action.MY_ORDER_NOW_TIME_VALUE_CODE,
            MY_ORDER_NOW_STATUS_VALUE : action.MY_ORDER_NOW_STATUS_VALUE,
            MY_ORDER_NOW_STATUS_CODE : action.MY_ORDER_NOW_STATUS_CODE,
            MY_ORDER_STATUS_TYPE : action.MY_ORDER_STATUS_TYPE
        });
        break;

        case MY_ORDER.MY_ORDER_NEW_TIME:
        return Object.assign({},state,{
            MY_ORDER_PAGE_CURRENT : action.MY_ORDER_PAGE_CURRENT,
            MY_ORDER_NOW_TIME_VALUE : action.MY_ORDER_NOW_TIME_VALUE,
            MY_ORDER_NOW_TIME_VALUE_CODE : action.MY_ORDER_NOW_TIME_VALUE_CODE,
            MY_ORDER_TIME_MODULE_SHOW : action.MY_ORDER_TIME_MODULE_SHOW,
        });
        break;

        case MY_ORDER.MY_ORDER_TIME_MODULE_SHOW:
        return Object.assign({},state,{
            MY_ORDER_TIME_MODULE_SHOW : action.MY_ORDER_TIME_MODULE_SHOW,
        });
        break;

        case MY_ORDER.MY_ORDER_STATUS_TYPE:
        return Object.assign({},state,{
            MY_ORDER_STATUS_TYPE : action.MY_ORDER_STATUS_TYPE,
        });
        break;

        case MY_ORDER.MY_ORDER_NEW_STATUS:
        return Object.assign({},state,{
            MY_ORDER_PAGE_CURRENT: action.MY_ORDER_PAGE_CURRENT,
            MY_ORDER_NOW_STATUS_VALUE: action.MY_ORDER_NOW_STATUS_VALUE,
            MY_ORDER_NOW_STATUS_CODE: action.MY_ORDER_NOW_STATUS_CODE,
            MY_ORDER_STATUS_MODULE_SHOW: action.MY_ORDER_STATUS_MODULE_SHOW,
        });
        break;

        case MY_ORDER.MY_ORDER_STATUS_MODULE_SHOW:
        return Object.assign({},state,{
            MY_ORDER_STATUS_MODULE_SHOW: action.MY_ORDER_STATUS_MODULE_SHOW,
        });
        break;

        case MY_ORDER.MY_ORDER_NEW_TAB:
        return Object.assign({},state,{
            MY_ORDER_PAGE_CURRENT: action.MY_ORDER_PAGE_CURRENT,
            MY_ORDER_NOW_STATUS_VALUE: action.MY_ORDER_NOW_STATUS_VALUE,
            MY_ORDER_NOW_STATUS_CODE: action.MY_ORDER_NOW_STATUS_CODE,
            MY_ORDER_STATUS_TYPE: action.MY_ORDER_STATUS_TYPE,
        });
        break;

        case MY_ORDER.MY_ORDER_PAGE_CURRENT:
        return Object.assign({},state,{
            MY_ORDER_PAGE_CURRENT: action.MY_ORDER_PAGE_CURRENT
        });
        break;

        case MY_ORDER.MY_ORDER_SHOW_COMMENTS:
        return Object.assign({},state,{
            MY_ORDER_SHOW_COMMENTS: action.MY_ORDER_SHOW_COMMENTS
        });
        break;

        case MY_ORDER.MY_ORDER_COMMENTS_NOW_OP:
        return Object.assign({},state,{
            MY_ORDER_COMMENTS_NOW_OP : action.MY_ORDER_COMMENTS_NOW_OP,
            MY_ORDER_COMMENTS_NOW_ORDER_ID : action.MY_ORDER_COMMENTS_NOW_ORDER_ID,
            MY_ORDER_COMMENTS_NOW_SKUID : action.MY_ORDER_COMMENTS_NOW_SKUID,
            MY_ORDER_SHOW_COMMENTS : action.MY_ORDER_SHOW_COMMENTS
        });
        break;

        case MY_ORDER.MY_ORDER_DOWN_PAY_BOX_SHOW:
        return Object.assign({},state,{
            MY_ORDER_DOWN_PAY_BOX_SHOW : action.MY_ORDER_DOWN_PAY_BOX_SHOW,
            MY_ORDER_NOW_PAY_ORDER_ID : action.MY_ORDER_NOW_PAY_ORDER_ID,
            MY_ORDER_NOW_PAY_MONEY : action.MY_ORDER_NOW_PAY_MONEY,
        });
        break;

        case MY_ORDER.MY_ORDER_CANCEL_REASON_SHOW:
        return Object.assign({},state,{
            MY_ORDER_CANCEL_REASON_SHOW : action.MY_ORDER_CANCEL_REASON_SHOW,
        });
        break;

        case MY_ORDER.MY_ORDER_ORDER_ID:
        return Object.assign({},state,{
            MY_ORDER_CANCEL_REASON_SHOW : action.MY_ORDER_CANCEL_REASON_SHOW,
            MY_ORDER_ORDER_ID : action.MY_ORDER_ORDER_ID,
            MY_ORDER_CANCEL_REASON_LIST : action.MY_ORDER_CANCEL_REASON_LIST,
            MY_ORDER_CANCEL_REASON_STATUS :action.MY_ORDER_CANCEL_REASON_STATUS,
            MY_ORDER_CANCEL_REASON_TYPE :action.MY_ORDER_CANCEL_REASON_TYPE,
        });
        break;

        case MY_ORDER.MY_ORDER_LOGISTIC_SHOW:
        return Object.assign({},state,{
            MY_ORDER_LOGISTIC_SHOW : action.MY_ORDER_LOGISTIC_SHOW,
            MY_ORDER_LOGISTIC_MODEL : action.MY_ORDER_LOGISTIC_MODEL,
            MY_ORDER_LOGISTIC_INDEX : action.MY_ORDER_LOGISTIC_INDEX,
        });
        break;
        case MY_ORDER.PAY_TOGETHER_POPUP_TOOGLE:
            return Object.assign({},state,{
                PAY_TOGETHER_POPUP_TOOGLE: action.PAY_TOGETHER_POPUP_TOOGLE,
                MERGE_ORDERS:action.MERGE_ORDERS
            })
        break; 
        case MY_ORDER.MY_ORDER_ORDER_CHECK:
            return Object.assign({},state,{
                MY_ORDER_ORDER_CHECK: action.MY_ORDER_ORDER_CHECK
            })
        break;         
        case MY_ORDER.DEPOSIT_COMMENT:
        return Object.assign({},state,{
            DEPOSIT_COMMENT: action.DEPOSIT_COMMENT
        })
    break; 
        
        default:
        return state;
        break;
    }
}


// WEBPACK FOOTER //
// ./common/reducers/myAccountOrder.js